import type { TimedMetadataItemModel } from '@mimir/web/model/timedMdf';

export type LogEventChange =
  | { type: 'added'; item: TimedMetadataItemModel }
  | { type: 'updated'; items: TimedMetadataItemModel[] }
  | { type: 'removed'; ids: string[] };

export type LogEventChangeListener = (change: LogEventChange) => void;

export interface LogEventNotifier {
  addListener(listener: LogEventChangeListener): void;
  removeListener(listener: LogEventChangeListener): void;
  notifyAdded(item: TimedMetadataItemModel): void;
  notifyUpdated(items: TimedMetadataItemModel[]): void;
  notifyRemoved(ids: string[]): void;
}

export function createLogEventNotifier(): LogEventNotifier {
  const listeners: LogEventChangeListener[] = [];

  function emit(change: LogEventChange) {
    for (const listener of listeners) {
      listener(change);
    }
  }

  return {
    addListener(listener: LogEventChangeListener) {
      listeners.push(listener);
    },
    removeListener(listener: LogEventChangeListener) {
      const index = listeners.indexOf(listener);
      if (index >= 0) listeners.splice(index, 1);
    },
    notifyAdded(item: TimedMetadataItemModel) {
      emit({ type: 'added', item });
    },
    notifyUpdated(items: TimedMetadataItemModel[]) {
      emit({ type: 'updated', items });
    },
    notifyRemoved(ids: string[]) {
      emit({ type: 'removed', ids });
    },
  };
}
